export const PAYMENT_REQUEST_START = 'PAYMENT_REQUEST_START';
export const PAYMENT_REQUEST_SUCCESS = 'PAYMENT_REQUEST_SUCCESS';
export const PAYMENT_REQUEST_FAIL = 'PAYMENT_REQUEST_FAIL';
export const PAYMENT_REQUEST_RESET = 'PAYMENT_REQUEST_RESET';
